import * as React from 'react';

import { translate } from '~l10n/client';

import { ViewPricingTableEventAdapter } from '~analytics/adapters/ViewPricingTableEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { ButtonProps, UIButton } from '~shared/components/buttons';
import { useDialogClose } from '~shared/components/Dialog';

interface Props extends Pick<ButtonProps, 'appearance' | 'isDisabled'> {
  paywallScreen: PaywallScreens;
}

export function PaywallUpgradeButton({ paywallScreen, ...props }: Props) {
  const closeDialog = useDialogClose();
  const routeToPricing = () => {
    closeDialog();
    new ViewPricingTableEventAdapter({
      source: 'paywall',
      paywall_feature: paywallScreen,
    }).sendAnalytics();
    window.SOCRATIVE.teacherRouter.routeToPricing();
  };

  return (
    <UIButton {...props} onClick={routeToPricing}>
      {translate('Upgrade')}
    </UIButton>
  );
}
